import React,{Component} from 'react';
import { addScaleCorrection, motion } from "framer-motion";
import classes from './nav.module.css';
import {Link} from 'react-router-dom';

class nav extends Component{
     state={
         active :window.location.href
     }
     setActive = (value)=>{
         this.setState({active:value});
     }
     static getDerivedStateFromProps(props,state){
          
         const url = window.location.href;
           let u = null;
           if(state.active==null)
           return{active:"About"}
         console.log(url);
         if(url.endsWith('/'))
          u= "About"
          else if(url.endsWith('/project'))
          u = "Project"
          else if(url.endsWith('/resume'))
           u = "Resume"
           else u = "About"
            
         return {active:u}
     }

    render(){
        let res = null;
        if(this.state.active==='About'){
            res = (
                <div className={classes.nav_items}>
                <Link to="/resume"><div className={classes.nav_item}onClick={()=>this.setActive('Resume')}>Resume </div></Link>
                <Link to="/project"> <div className={classes.nav_item}onClick={()=>this.setActive('Project')}>Projects </div></Link>   
                    
                
                </div>

            )
           
        }
        else if(this.state.active==='Resume'){
            res = (
                <div className={classes.nav_items}>
                <Link to="/"> <div className={classes.nav_item}onClick={()=>this.setActive('About')}>About </div></Link>
                <Link to="/project"> <div className={classes.nav_item}onClick={()=>this.setActive('Project')}>Projects </div></Link>    
              
            </div>

            )
        }
        else{
            res = (
                <div className={classes.nav_items}>
                <Link to="/"> <div className={classes.nav_item}onClick={()=>this.setActive('About')}>About </div></Link>
                <Link to="/resume"> <div className={classes.nav_item}onClick={()=>this.setActive('Resume')}>Projects </div></Link>    
              
            </div>

            )
        }

        const ani = {
            hidden:{
                y:'-30vh',
                opacity:0
            },
            visible:{
                y:0,
                opacity:1,
                transition:{
                    delay:3,duration:4,type:'spring'
                }
               

            }
        }

        return(
            <motion.div className={classes.nav}
               variants={ani}
               initial='hidden'
               animate='visible'
            >
                <div className={classes.active}>
                   {
                       this.state.active
                   }
                </div>
                {
                    res
                }
    
                
    
            </motion.div>
        )

    }
    
}

export default nav;